import React, { useEffect } from 'react';
import { Routes, Route, useNavigate, useLocation } from "react-router-dom";

// STATE
import { useGlobalState } from './index';

// PROVIDER
import { getProvider } from './provider';

// MODULES
import Claim from './Claim';
import Home from './Home';
import Header from './shared/Header';
import ClaimStatus from './ClaimStatus';

// STYLES
import './App.scss';

function App() {

  const [state, dispatch] = useGlobalState();
  const navigate = useNavigate();
  const location = useLocation();

  const checkNetworkId = async (): Promise<void> => {

    //const provider = await getProvider();
    //const chainId = await provider.eth.getChainId();
    const chainId = 1;

    if (chainId !== parseInt(process.env.REACT_APP_NETWORK_ID as string)) {
      dispatch({ connected: false, chainId });
      if (location.pathname !== '/claim-status') {
        navigate('/');
      }
    } else {
      dispatch({ chainId });
      await getAccount();
    }
  };

  const getAccount = async (): Promise<void> => {

    const provider = await getProvider();
    const accounts = await provider.eth.getAccounts();

    if (accounts.length) {
      dispatch({ user: accounts[0], connected: true });
    } else {
      dispatch({ user: null, connected: false });
    }
  };

  const listenNetworkChange = (): void => {
    window.ethereum?.on('chainChanged', (chainId: string) => {
      dispatch({ chainId: parseInt(chainId) });
    });
  };

  const listenAccountChange = (): void => {
    window.ethereum?.on('accountsChanged', (accounts: string[]) => {
      if (accounts.length) dispatch({ user: accounts[0], connected: true });
    });
  };

  const checkProvider = async (): Promise<void> => {
    if (window.ethereum) {
      await checkNetworkId();
    }
  };

  useEffect(() => {
    //checkNetworkId();
  }, [state.chainId]);

  useEffect(() => {
    listenAccountChange();
    listenNetworkChange();
    checkProvider();
  }, [state.connected]);

  return (
    <div className="app-container">
      <Header />
      <Routes>
        {/* <Route path="/" element={<Soon />} /> */}
        <Route path="/" element={<Home />} />
        <Route path="/claim" element={<Claim />} />
        <Route path="/claim-status" element={<ClaimStatus />} />
      </Routes>
    </div>
  );

}

export default App;
